import { useCallback } from 'react';

import { capturePostHogEvent } from '../services/postHogService';

// Returns a `track` function for CustomButton-style click instrumentation.
// Fires a single `button_clicked` event with normalized metadata so funnels
// can filter by id, label, kind (button/link/anchor/copy), or destination.
//
// Skips capture when neither `id` nor `label` is available — keeps the event
// stream readable by ignoring icon-only / anonymous buttons. The `screen`
// and `modal` super-properties are attached automatically by their wrappers.
export default function useButtonTracking() {
  return useCallback(meta => {
    if (!meta) return;
    if (!meta.id && !meta.label) return;
    capturePostHogEvent('button_clicked', {
      id: meta.id || undefined,
      label: meta.label || undefined,
      kind: meta.kind || 'button',
      to: meta.to || undefined,
      target: meta.target || undefined,
      variant: meta.variant || undefined
    });
  }, []);
}
